




























































































































import { Component, Mixins } from "vue-property-decorator";
import BaseServiceMixin from "../mixins/base.service.mixin";
import { XeroInvoiceModel } from "../models/XeroInvoiceModel";
import Filters from "@/common/Filters";
import XeroService from "@/services/xero.service";
import XeroInvoiceSearchModel from "@/models/XeroInvoiceSearchModel";
import { XeroInvoiceStatus, CurrencyCode } from "../common/enum";
import Shared from "@/common/shared";

@Component({
  filters: {
    dateFormat: Filters.formatDate,
  },
})
export default class Invoices extends Mixins(BaseServiceMixin) {
  private invoices: XeroInvoiceModel[] = [];
  private loading = false;
  private xeroService!: XeroService;
  private invoiceFilter = new XeroInvoiceSearchModel();
  private filterStatus: string | null = null;
  private paidStr = "Paid";
  private awaitingStr = "Awaiting Payment";
  private invoiceLinkTimeout: NodeJS.Timeout | null = null;

  private get status(): XeroInvoiceStatus[] {
    switch (this.filterStatus) {
      case this.paidStr:
        return [XeroInvoiceStatus.PAID, XeroInvoiceStatus.VOIDED];
      case this.awaitingStr:
        return [XeroInvoiceStatus.DRAFT, XeroInvoiceStatus.SUBMITTED, XeroInvoiceStatus.AUTHORISED];
      default:
        return [];
    }
  }

  public async created() {
    this.xeroService = new XeroService(this.axiosInstance);
  }

  private async mounted() {
    await this.getInvoices();
  }

  private async getInvoices() {
    this.loading = true;
    try {
      this.invoiceFilter.status = this.status;
      if (this.invoiceFilter.invoiceNumber) {
        this.invoiceFilter.invoiceNumber = this.invoiceFilter.invoiceNumber.trim();
      }

      this.invoices = await this.xeroService.getInvoices(this.invoiceFilter);
    } catch (error) {
      // Handle errors
    } finally {
      this.loading = false;
    }
  }

  private getInvoiceStatus(status: XeroInvoiceStatus): string {
    switch (status) {
      case XeroInvoiceStatus.PAID:
      case XeroInvoiceStatus.VOIDED:
        return this.paidStr;
      case XeroInvoiceStatus.DRAFT:
      case XeroInvoiceStatus.SUBMITTED:
      case XeroInvoiceStatus.AUTHORISED:
        return this.awaitingStr;
      default:
        return XeroInvoiceStatus[status];
    }
  }

  private getInvoiceStatusColor(status: XeroInvoiceStatus): string {
    switch (status) {
      case XeroInvoiceStatus.PAID:
      case XeroInvoiceStatus.VOIDED:
        return "is-success";
      case XeroInvoiceStatus.DRAFT:
      case XeroInvoiceStatus.SUBMITTED:
      case XeroInvoiceStatus.AUTHORISED:
      default:
        return "is-danger";
    }
  }

  private async onPrevious() {
    if (this.invoiceFilter.page <= 1) {
      return;
    }
    this.invoiceFilter.page -= 1;
    this.getInvoices();
  }

  private async onNext() {
    if (this.invoices.length < 100) {
      return;
    }
    this.invoiceFilter.page += 1;
    this.getInvoices();
  }

  private clearFilter() {
    this.invoiceFilter = new XeroInvoiceSearchModel();
    this.filterStatus = null;
    this.getInvoices();
  }

  private getFormattedCurrency(invoice: XeroInvoiceModel): string {
    const country = CurrencyCode[invoice.currencyCode] || null;
    if (country) {
      return new Intl.NumberFormat("en", { style: "currency", currency: country }).format(invoice.total);
    }
    return invoice.total.toString();
  }

  private async onSelect(invoice: XeroInvoiceModel) {
    try {
      if (!invoice.invoiceUrl) {
        this.loading = true;
        invoice.invoiceUrl = await this.xeroService.getOnlineInvoiceUrl(invoice.invoiceID);
      }

      this.$buefy.dialog.confirm({
        title: "Your invoice is ready.",
        type: "is-success",
        confirmText: "Continue",
        cancelText: "Cancel",
        message: "Click continue to view invoice.",
        onConfirm: () => this.openInvoiceWindow(invoice.invoiceUrl),
      });
    } catch (error) {
      Shared.showToastMessage(error.message || Shared.messages.SOMETHING_WRONG, "is-danger");
    } finally {
      this.loading = false;
    }
  }

  private openInvoiceWindow(invoiceUrl: string) {
    window.open(invoiceUrl, "_blank");
  }
}
